import {StyleSheet} from 'react-native';

import {default as SkillzStyle} from 'SkillzStyle';

const {fontBold, fontRegular, fontExtraBold, fontSemiBold, tabHighlightColor, fontMedium} =
  SkillzStyle.fullStyles;

export default StyleSheet.create({
  mainContainer: {
    flex: 1,
    backgroundColor: '#FAFAFA',
  },
  verifyEmailContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    marginTop: 20,
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  emailIcon: {
    width: 60,
    height: 45,
    alignSelf: 'center',
    marginBottom: 16,
  },
  headerTitleText: {
    fontSize: 20,
    textAlign: 'center',
    marginBottom: 8,
    color: '#333',
    lineHeight: 24,
    letterSpacing: -0.6,
    ...fontExtraBold,
  },
  headerSubtitleText: {
    fontSize: 13,
    textAlign: 'center',
    paddingHorizontal: 35,
    letterSpacing: -0.13,
    lineHeight: 18,
    color: '#333',
    ...fontRegular,
  },
  headerSubtitleBoldText: {
    fontSize: 13,
    textAlign: 'center',
    letterSpacing: -0.13,
    lineHeight: 18,
    color: '#333',
    ...fontSemiBold,
  },
  inputFormContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 14,
    paddingHorizontal: 20,
    justifyContent: 'center',
    marginTop: 24,
  },
  inputStyle: {
    width: 44,
    padding: 10,
    fontSize: 18,
    height: 62,
    backgroundColor: '#fff',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#797979',
    textAlign: 'center',
    ...fontRegular,
    color: '#000',
  },
  inputStyleFocused: {
    width: 44,
    padding: 10,
    fontSize: 18,
    height: 62,
    backgroundColor: '#fff',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: tabHighlightColor.color,
    textAlign: 'center',
    ...fontRegular,
    color: '#000',
  },
  buttonContainer: {
    marginTop: 20,
    marginHorizontal: 10,
  },

  verificationErrorText: {
    marginTop: 24,
    color: 'red',
    textAlign: 'center',
    width: '80%',
    alignSelf: 'center',
    marginBottom: 8,
    letterSpacing: -0.13,
    fontSize: 13,
    lineHeight: 18,
    ...fontRegular,
  },
  verificationErrorDismiss: {
    color: '#367BCE',
    textDecorationLine: 'underline',
    textAlign: 'center',
    marginBottom: 8,
    letterSpacing: -0.13,
    fontSize: 13,
    lineHeight: 18,
    ...fontRegular,
  },
  resendCodeContainer: {
    marginTop: 24,
    marginBottom: 20,
  },
  didntReceiveLine: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'center',
  },
  resendCodeText: {
    textAlign: 'center',
    marginBottom: 8,
    letterSpacing: -0.13,
    fontSize: 13,
    lineHeight: 18,
    color: '#3A3A3A',
    ...fontRegular,
  },
  resendCodeTextBold: {
    textAlign: 'center',
    marginBottom: 8,
    letterSpacing: -0.13,
    fontSize: 13,
    lineHeight: 18,
    color: '#3A3A3A',
    ...fontBold,
  },
  resendCodeLinkText: {
    textAlign: 'center',
    color: '#367BCE',
    letterSpacing: -0.13,
    fontSize: 13,
    lineHeight: 18,
    ...fontRegular,
  },
  aeropayIcon: {
    width: 139,
    height: 50,
    alignSelf: 'center',
    marginTop: 5,
    marginBottom: 40,
  },
  supportSection: {
    borderWidth: 1,
    borderRadius: 5,
    borderColor: '#DDDDDD',
    padding: 15,
    width: '90%',
    alignSelf: 'center',
    bottom: 15,
  },
  somethingWrongText: {
    textAlign: 'center',
    marginBottom: 8,
    letterSpacing: -0.13,
    fontSize: 13,
    lineHeight: 18,
    color: '#3A3A3A',
    ...fontRegular,
  },
  supportEmail: {
    color: '#367BCE',
    textAlign: 'center',
    ...fontSemiBold,
  },
  shieldIcon: {
    width: 17,
    height: 19,
    flexShrink: 0,
  },
  // PUSH BUTTON STYLES
  submitText: {
    letterSpacing: -0.54,
    color: '#FFFFFF',
    fontSize: 18,
    ...fontExtraBold,
  },

  submitButton: {
    marginTop: 10,
    height: 45,
  },
});
